import httpHelper from "../helpers/http_helper";
import app from "../main";
import dateformat from "dateformat";

const meetingService = {
    freeJoin: async function (data) {
        return await httpHelper.post("/RestApi/Service/JoinMeetingVer2", data);
    },
    initStartMeeting: async function () {
        return await httpHelper.post("/RestApi/Service/InitStartMeeting");
    },
    startMeeting: async function (data) {
        return await httpHelper.post("/RestApi/Service/StartMeetingVer2", data);
    },
    initAddJoinRequest: async function (data) {
        return await httpHelper.post("/RestApi/Service/InitAddJoinRequest", data);
    },
    joinMeeting: async function (data) {
        return await httpHelper.post("/RestApi/Service/JoinMeetingScheduleVer2", data);
    },
    sendJoinRequest: async function (data) {
        return await httpHelper.post("/RestApi/Service/SendJoinRequest", data);
    },
    utilities: async function () {
        return await httpHelper.post("/RestApi/Service/MeetingUtilities");
    },
    offlineParticipants: async function () {
        return await httpHelper.post("/RestApi/Service/OfflineParticipants");
    },
    blockMeetingParticipant: async function (data) {
        return await httpHelper.post("/RestApi/Service/BlockMeetingParticipant", data);
    },
    meetingSettings: async function() {
        return await httpHelper.post("/RestApi/Service/MeetingSettings");
    },
    saveMeetingSettings: async function (data) {
        return await httpHelper.post("/RestApi/Service/SaveMeetingSettings", data);
    },
    meetingSchedules: async function() {
        return await httpHelper.post("/RestApi/Service/MeetingSchedules");
    },
    deleteMeetingSchedule: async function (id) {
        return await httpHelper.post("/RestApi/Service/DeleteMeetingSchedules", {id});
    },
    editMeetingSchedule2: async function (id) {
        return await httpHelper.post("/RestApi/Service/EditMeetingSchedule2Ver2", {id});
    },
    editMeetingSchedule3: async function (id) {
        return await httpHelper.post("/RestApi/Service/EditMeetingSchedule3Ver2", {id});
    },
    saveEditMeetingSchedule2: async function (data) {
        let arrFromTime = data.fromTime.split(":");
        let arrToTime = data.toTime.split(":");
        let arrDate = data.date.split('T')
        let date = new Date(arrDate[0]);
        let submitData = {
            id: data.id,
            name: data.name,
            fromHour: parseInt(arrFromTime[0]),
            fromMin: parseInt(arrFromTime[1]),
            toHour: parseInt(arrToTime[0]),
            toMin: parseInt(arrToTime[1]),
            date: dateformat(date, app.$t("dateformat")),
            isOverrideMeetingCogs: data.isOverrideMeetingCogs,
            isTurnOnParticipantVideos: !data.isTurnOffParticipantVideos,
            isTurnOnHostVideo: true,
            isTurnOnDinhDong: !data.isTurnOffDinhDong,
            isBlocked: data.isBlocked,
            idAuthen: data.idAuthen
        }

        return await httpHelper.post("/RestApi/Service/SaveEditMeetingSchedule2Ver2", submitData);
    },
    saveEditMeetingSchedule3: async function (data) {
        let arrFromTime = data.fromTime.split(":");
        let arrToTime = data.toTime.split(":");
        let submitData = {
            id: data.id,
            name: data.name,
            fromHour: parseInt(arrFromTime[0]),
            fromMin: parseInt(arrFromTime[1]),
            toHour: parseInt(arrToTime[0]),
            toMin: parseInt(arrToTime[1]),
            fromDate: dateformat(new Date(data.fromDate.split('T')[0]), app.$t("dateformat")),
            toDate: dateformat(new Date(data.toDate.split('T')[0]), app.$t("dateformat")),
            isOverrideMeetingCogs: data.isOverrideMeetingCogs,
            isTurnOnParticipantVideos: !data.isTurnOffParticipantVideos,
            isTurnOnHostVideo: true,
            isTurnOnDinhDong: !data.isTurnOffDinhDong,
            isBlocked: data.isBlocked,
            idAuthen: data.idAuthen,
            dayOfWeeks: data.dayOfWeeks.reduce((a, b) => a + b)
        }

        return await httpHelper.post("/RestApi/Service/SaveEditMeetingSchedule3Ver2", submitData);
    },
    addMeetingSchedule2: async function (data) {
        let arrFromTime = data.fromTime.split(":");
        let arrToTime = data.toTime.split(":");
        let arrDate = data.date.split('T')
        let date = new Date(arrDate[0]);
        let submitData = {
            id: data.id,
            name: data.name,
            fromHour: parseInt(arrFromTime[0]),
            fromMin: parseInt(arrFromTime[1]),
            toHour: parseInt(arrToTime[0]),
            toMin: parseInt(arrToTime[1]),
            date: dateformat(date, app.$t("dateformat")),
            isOverrideMeetingCogs: data.isOverrideMeetingCogs,
            isTurnOnParticipantVideos: !data.isTurnOffParticipantVideos,
            isTurnOnHostVideo: true,
            isTurnOnDinhDong: !data.isTurnOffDinhDong,
            isBlocked: data.isBlocked,
            idAuthen: data.idAuthen
        }

        return await httpHelper.post("/RestApi/Service/AddMeetingSchedule2Ver2", submitData);
    },
    addMeetingSchedule3: async function (data) {
        let arrFromTime = data.fromTime.split(":");
        let arrToTime = data.toTime.split(":");
        let submitData = {
            id: data.id,
            name: data.name,
            fromHour: parseInt(arrFromTime[0]),
            fromMin: parseInt(arrFromTime[1]),
            toHour: parseInt(arrToTime[0]),
            toMin: parseInt(arrToTime[1]),
            fromDate: dateformat(new Date(data.fromDate.split('T')[0]), app.$t("dateformat")),
            toDate: dateformat(new Date(data.toDate.split('T')[0]), app.$t("dateformat")),
            isOverrideMeetingCogs: data.isOverrideMeetingCogs,
            isTurnOnParticipantVideos: !data.isTurnOffParticipantVideos,
            isTurnOnHostVideo: true,
            isTurnOnDinhDong: !data.isTurnOffDinhDong,
            isBlocked: data.isBlocked,
            idAuthen: data.idAuthen,
            dayOfWeeks: data.dayOfWeeks.reduce((a, b) => a + b)
        }

        return await httpHelper.post("/RestApi/Service/AddMeetingSchedule3Ver2", submitData);
    },
    initAddInviteRequest: async function () {
        return await httpHelper.post("/RestApi/Service/InitAddInviteRequest");
    },
    sendInviteRequest: async function (data) {
        return await httpHelper.post("/RestApi/Service/SendInviteRequest", data);
    },
    meetingParticipants: async function(data) {
        return await httpHelper.post("/RestApi/Service/MeetingParticipants", data);
    },
    initMeetingParticipants: async function() {
        return await httpHelper.post("/RestApi/Service/InitMeetingParticipants");
    },
    deleteMeetingParticipant: async function(data) {
        return await httpHelper.post("/RestApi/Service/DeleteMeetingParticipant", data);
    },
    async meetingParticipantExport(data) {
        let arrFromTime = data.fromTime.split(":");
        let arrToTime = data.toTime.split(":");
        let submitData = {
            id: data.id,
            fromHour: parseInt(arrFromTime[0]),
            fromMin: parseInt(arrFromTime[1]),
            toHour: parseInt(arrToTime[0]),
            toMin: parseInt(arrToTime[1]),
            fromDate: dateformat(new Date(data.date), app.$t("dateformat"))
        }

        return await httpHelper.post("/RestApi/Service/MeetingParticipantExport", submitData);
    },
    async initAddParticipantsToSchedule(data) {
        return await httpHelper.post("/RestApi/Service/InitAddParticipantsToSchedule", data);
    },
    async addParticipantToSchedule(data) {
        return await httpHelper.post("/RestApi/Service/AddParticipantToSchedule", data);
    }
}

export default meetingService;